<i18n src="./resources/locales.json"></i18n>

<template>
  <v-navigation-drawer
    :value="open"
    class="elevation-5 ecs-notifications-container"
    :offline="isOfflineModeEnabled"
    width="350"
    app
    clipped
    fixed
    hide-overlay
    right
    stateless
    temporary
  >
    <v-tabs slider-color="primary" grow>
      <v-tab id="notifications-tab" class="ecs-tab surface lighten-1" href="#notifications-tab">
        <span>
          {{ panelName }}
        </span>
      </v-tab>
    </v-tabs>
    <EcsNotificationList class="ecs-notification-list" :notification-list="items" @onItemClick="onItemClick">
      <slot name="fab"></slot>
    </EcsNotificationList>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex';
import EcsNotificationList from '@/components/ecs-notifications-panel/ecs-notification-list/EcsNotificationList';

export default {
  name: 'EcsNotificationsPanel',

  components: {
    EcsNotificationList
  },

  props: {
    panelName: {
      type: String,
      default: ''
    },
    isCallbacksPanel: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      required: true,
      default() {
        return [];
      }
    },
    open: {
      type: Boolean,
      required: true
    }
  },

  computed: {
    ...mapGetters('SETTINGS', ['isOfflineModeEnabled'])
  },

  methods: {
    onItemClick(item, action) {
      this.$emit('onItemClick', item, action);
    }
  }
};
</script>

<style scoped>
.ecs-tab {
  letter-spacing: 0.14em;
}

.ecs-notifications-container {
  background: var(--v-surface-lighten1);
  border-style: solid;
  border-width: 1px;
  border-color: #0000001a;
  border-right: none;
  height: calc(100% - 64px) !important;
  top: 64px !important;
  z-index: 120;
}

[offline].ecs-notifications-container {
  height: calc(100% - 94px) !important;
  top: 94px !important;
}

.ecs-notification-list {
  height: calc(100% - 48px);
}
</style>
